import React from 'react';

const InfoPanelMultipleAssets = ({

  itemCount,
  onDeleteClick,
  onMoveClick

})=>
  <div className="asset-info-area">

    <div className="asset-count-wrapper">
      <div className="asset-count">
        {itemCount}
      </div>
      Assets Selected
    </div>

    <div className="asset-details">
      <div className="move-asset action-move-item info-action-button" onClick={onMoveClick}> 
        <i className="fa fa-share"></i>
        Move
      </div>
      <div className="delete-asset action-delete-item info-action-button" onClick={onDeleteClick}>
        <i className="fa fa-trash"></i>
        Delete
      </div>
    </div>

  </div>;


export default InfoPanelMultipleAssets;